<script setup lang="ts">
import type { Panel, Theme } from './report-typing';

import { computed, inject } from 'vue';

import ReportSectionRenderer from './ReportSectionRenderer.vue';

const props = defineProps<{
  panel: Panel;
}>();

const theme = inject<Theme>('reportTheme');

const panelStyle = computed(() => {
  const base: Record<string, string> = {
    padding: `${props.panel.padding.top}px ${props.panel.padding.right}px ${props.panel.padding.bottom}px ${props.panel.padding.left}px`,
    gap: `${props.panel.gap}px`,
  };

  if (props.panel.background) {
    base.background = props.panel.background;
  }
  else if (theme) {
    base.background = theme.colors.background;
  }

  return base;
});
</script>

<template>
  <div class="report-panel" :style="panelStyle">
    <ReportSectionRenderer
      v-for="section in panel.sections"
      :key="section.id"
      :section="section"
    />
  </div>
</template>

<style scoped>
.report-panel {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}
</style>
